<script>
    import Button from "@smui/button";
    import Checkbox from "@smui/checkbox";
    import FormField from "@smui/form-field";
    import Select, { Option } from "@smui/select";

    import Textfield from "@smui/textfield";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import Address from "../../components/Address.svelte";
    import loading from "../../components/loading";
    import ShippingKind from "../../components/ShippingKind.svelte";
    import snackbar from "../../components/snackbar";

    import title from "../../components/title";
    import page from "../../page";
    import { getObject, setObject } from "../../session";

    export let location;
    let isLoading = false;

    let name = "",
        phone = "";

    let province,
        city,
        district,
        address = "";

    let weight = 1,
        newWeight = 1;
    let lastRefresh = 0;

    let origin = "",
        destination = "";

    let isInsurance = false;

    let price = 0,
        insurance = 0,
        tarif = 0;

    let packageKind = "Paket";
    let shippingKind = "";

    let content = "";

    let note = "";

    // $: address.length = 10 && page.scrollToBottom();
    $: calculateInsurance(isInsurance, price);

    function selectWeight() {
        if (newWeight != "" && newWeight > 0) {
            weight = newWeight;
            lastRefresh = new Date();
        } else weight = 0;
    }

    function calculateInsurance() {
        if (isInsurance && price >= 500000) insurance = (price * 0.25) / 100;
        else insurance = 0;
        page.scrollToBottom();
    }

    function shippingSelected(ev) {
        shippingKind = ev.detail;
        tarif = shippingKind.tariff;
        packageKind = "Paket";
        page.scrollToBottom();
    }

    function value(val) {
        return val == "" ? "-" : val;
    }

    function next() {
        if (address.length < 8) {
            snackbar.open("Alamat belum diisi atau kurang dari 8 huruf");
            return;
        }
        const order = getObject("order");
        order["destination_code"] = destination;
        order["recipient_name"] = name;
        order["recipient_phone"] = phone;
        order["recipient_province"] = province;
        order["recipient_city"] = city;
        order["recipient_district"] = district;
        order["recipient_address"] = address;
        order["recipient_zipcode"] = "-";
        order["delivery_type"] = shippingKind.service;
        order["delivery_type_description"] = shippingKind.description;
        order["parcel_category"] = value(packageKind);
        order["parcel_content"] = value(content);
        order["parcel_value"] = price;
        order["parcel_weight"] = weight;
        order["insurance"] = insurance;
        order["tarif"] = tarif;
        order["notes"] = note;

        setObject("order", order);
        console.log(order);
        navigate("/order/review");
    }

    onMount(() => {
        title.set("Tujuan");
        const order = getObject("order");
        origin = order.origin_code;
        loading.isLoading().subscribe((val) => (isLoading = val));
    });
</script>

<style lang="scss">
    .weight {
        & .number {
            width: 136px;
        }
    }
    .content {
        margin-bottom: 56px;
    }
    .footer {
        color: #fff;
        background-color: #333;
        height: 56px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 8px;
    }
</style>

<div class="content">
    <Textfield
        bind:value={name}
        variant="outlined"
        label="Nama"
        disabled={isLoading} />
    <Textfield
        bind:value={phone}
        variant="outlined"
        label="Telepon"
        disabled={isLoading} />
    <Address
        mode="destination"
        bind:province
        bind:city
        bind:district
        bind:address
        bind:code={destination}
        bind:disabled={isLoading} />
    <div class="weight row gap vcenter">
        <div class="number">
            <Textfield
                type="number"
                input$step="0.1"
                bind:value={newWeight}
                variant="outlined"
                label="Berat paket"
                input$class="text-center"
                input$placeholder="Berapa berat paketnya?"
                disabled={isLoading} />
        </div>
        Kg
        <Button
            color="primary"
            variant="unelevated"
            on:click={selectWeight}
            disabled={isLoading}>
            Hitung
        </Button>
    </div>
    <ShippingKind
        bind:origin
        bind:destination
        bind:weight
        bind:lastRefresh
        on:select={shippingSelected} />
    {#if shippingKind != ''}
        <div class="padding">
            <div>
                Jika nilai barang lebih dari Rp500.000 bisa ditambahkan asuransi
            </div>
            <FormField>
                <Checkbox bind:checked={isInsurance} />
                <span slot="label">Tambahkan asuransi</span>
            </FormField>
        </div>
    {/if}
    {#if isInsurance}
        <div class="text">Masukkan perkiraan harga:</div>
        <div class="row">
            <Textfield
                type="number"
                bind:value={price}
                variant="outlined"
                label="Harga barang"
                input$class="text-center"
                input$placeholder="Masukkan harga barang" />
        </div>
    {/if}
    {#if shippingKind != ''}
        <div class="row">
            <Select
                bind:value={packageKind}
                variant="outlined"
                label="Kategori Paket"
                enhanced>
                <Option value="Paket">Paket</Option>
                <Option value="Dokumen">Dokumen</Option>
            </Select>
        </div>
        <Textfield
            bind:value={content}
            variant="outlined"
            label="Isi Barang"
            input$placeholder="Misalkan: buku, pakaian, dll" />
        <Textfield
            bind:value={note}
            variant="outlined"
            label="Keterangan"
            input$placeholder="Misalkan: jangan dibanting" />
    {/if}
</div>

{#if shippingKind != ''}
    <div class="footer row gap vcenter">
        <div class="column fill">
            <div class="row">
                <div class="fill">Asuransi:</div>
                Rp.
                {insurance}
            </div>
            <div class="row">
                <div class="fill">Total:</div>
                Rp.
                {+tarif + +insurance}
            </div>
        </div>
        <div>
            <Button on:click={next} variant="unelevated" class="rounded">
                OK
            </Button>
        </div>
    </div>
{/if}
